import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import logger from "redux-logger";
import rootReducer from "./rootReducers";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

let middleware = [ thunk ]
if (process.env.NODE_ENV !== 'production') {
  let loggerMiddleware = logger;
  middleware = [ ...middleware, loggerMiddleware ]
}
export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export const persistor = persistStore(store);

export default { store, persistor };
